import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Dialog as MUIDialog,
} from "@mui/material";
import { isString } from "app/helpers/string";

import { useDialogControlContext, useDialogDataContext } from "./context";

export const Dialog = () => {
  const dialogData = useDialogDataContext();
  const dialogControl = useDialogControlContext();

  if (!dialogControl || !dialogData) {
    throw new Error(
      "Layout global Dialog component is used outside of DialogContextProvider",
    );
  }

  const dialogContent = (
    <>
      {dialogData.dialogContent?.title ? (
        <DialogTitle id="alert-dialog-title">
          {dialogData.dialogContent?.title}
        </DialogTitle>
      ) : null}
      {isString(dialogData.dialogContent?.content) ? (
        <DialogContent id="alert-dialog-description">
          <DialogContentText>
            {dialogData.dialogContent?.content}
          </DialogContentText>
        </DialogContent>
      ) : (
        dialogData.dialogContent?.content
      )}
      {dialogData.dialogContent?.actions &&
      dialogData.dialogContent.actions.length > 0 ? (
        <DialogActions>
          {dialogData.dialogContent.actions.map((action) => (
            <Button
              color={action.color || "inherit"}
              key={action.label}
              onClick={() => {
                action.onClick?.();
                if (action.type !== "submit") {
                  dialogControl.closeDialog();
                }
              }}
              type={action.type}
              variant="contained"
            >
              {action.label}
            </Button>
          ))}
        </DialogActions>
      ) : null}
    </>
  );

  return (
    <MUIDialog
      aria-describedby="alert-dialog-description"
      aria-labelledby="alert-dialog-title"
      maxWidth={dialogData.dialogContent?.disableMaxWidth ? false : undefined}
      onClose={dialogControl.closeDialog}
      open={dialogData.isOpened}
    >
      {dialogData.dialogContent?.wrapper?.({ children: dialogContent }) ??
        dialogContent}
    </MUIDialog>
  );
};
